'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _components = require('../../components');

var _TargetDateSeriesNameHeader = require('./TargetDateSeriesNameHeader.css');

var _TargetDateSeriesNameHeader2 = _interopRequireDefault(_TargetDateSeriesNameHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TargetDateSeriesNameHeader = (_dec = (0, _reactCssModules2.default)(_TargetDateSeriesNameHeader2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TargetDateSeriesNameHeader, _Component);

  function TargetDateSeriesNameHeader(props) {
    (0, _classCallCheck3.default)(this, TargetDateSeriesNameHeader);
    return (0, _possibleConstructorReturn3.default)(this, (TargetDateSeriesNameHeader.__proto__ || (0, _getPrototypeOf2.default)(TargetDateSeriesNameHeader)).call(this, props));
  }

  (0, _createClass3.default)(TargetDateSeriesNameHeader, [{
    key: 'render',
    value: function render() {
      var targetDateSeries = this.props.targetDateSeries;


      var fileName = _format2.default.imgPath(targetDateSeries.fund_family_label);
      var hasLogo = false;
      var companyLogo = null;
      try {
        companyLogo = require('../../../static/images/fam/' + fileName + '.png');
        hasLogo = true;
      } catch (e) {
        console.log('');
      }

      // const famUrl = config.routes.families+'?q='+encodeURIComponent(targetDateSeries.fund_family_label)

      //
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'name-flex' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h1',
              { styleName: 'name' },
              targetDateSeries.strategy_name,
              targetDateSeries.sustainable_investment ? _react2.default.createElement(
                'span',
                { styleName: 'leaf' },
                _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-leaf' })
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { styleName: 'name-label-logo' },
              hasLogo ? _react2.default.createElement('img', {
                styleName: 'name-logo',
                src: companyLogo,
                alt: targetDateSeries.fund_family_label
              }) : _react2.default.createElement(
                'span',
                null,
                targetDateSeries.fund_family_label
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'name-label' },
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.routes.targetDateFunds,
                  title: 'Target date funds',
                  xstrong: true
                },
                'Target date fund series'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'name-label' },
              'Rated as ',
              _react2.default.createElement(
                'b',
                null,
                targetDateSeries.fund_legal_name
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'name-label' },
              'Portfolio date ',
              _react2.default.createElement(
                'b',
                null,
                (0, _moment2.default)(targetDateSeries.portfolio_date).format('MMM YYYY')
              )
            )
          )
        )
      );
    }
  }]);
  return TargetDateSeriesNameHeader;
}(_react.Component), _class2.propTypes = {
  // the target date series object
  targetDateSeries: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = TargetDateSeriesNameHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TargetDateSeriesNameHeader/TargetDateSeriesNameHeader.js
// module id = 1453
// module chunks = 0